import { useContext } from 'react'
import { FamilyContext } from '../../Context/FamilyHeadContext'
import { API_URL, doApiGet } from '../../services/apiService'
import { transformToRDTNode } from './Stage1_Transform'
import { attachSubtree } from './Stage2_Subtree'

export function useTreeExtension(
    treeData,
    setTreeData,
    expandedNodes,
    setExpandedNodes,
) {
    const { isMainSite } = useContext(FamilyContext)

    const handleNodeClick = async (hierarchyPointNode) => {
        const nodeDatum = hierarchyPointNode.data
        const targetGedId = nodeDatum.attributes?.isMarriage
            ? nodeDatum.spouses.find((sp) => sp.isPrimary)?.gedId
            : nodeDatum.attributes?.gedId

        if (!targetGedId) {
            console.error('No targetGedId found for node:', nodeDatum)
            return
        }

        if (expandedNodes.has(targetGedId)) {
            closeNode(targetGedId)
        } else {
            await expandNode(targetGedId)
        }
    }

    const closeNode = (targetGedId) => {
        const clonedTree = structuredClone(treeData)

        const removeChildren = (node) => {
            if (!node) return false

            if (
                node.attributes?.isMarriage &&
                node.spouses?.some((sp) => sp.gedId === targetGedId)
            ) {
                node.children = []
                return true
            }

            if (node.attributes?.gedId === targetGedId) {
                node.children = []
                return true
            }

            if (node.children) {
                for (const child of node.children) {
                    if (removeChildren(child)) return true
                }
            }
            return false
        }

        if (removeChildren(clonedTree)) {
            const newExpandedNodes = new Set(expandedNodes)
            newExpandedNodes.delete(targetGedId)
            setExpandedNodes(newExpandedNodes)
            setTreeData(clonedTree)
        }
    }

    const expandNode = async (targetGedId) => {
        try {
            const url = `${API_URL}/people/family-tree/${targetGedId}/${
                isMainSite === 'bazach' ? 'bazach' : 'huminer'
            }`

            const data = await doApiGet(url)

            if (!data) {
                console.error('No data returned from API')
                return
            }

            const newSubtree = transformToRDTNode(data)

            const clonedTree = structuredClone(treeData)

            if (attachSubtree(clonedTree, targetGedId, newSubtree)) {
                console.log('Subtree attached successfully')
                const newExpandedNodes = new Set(expandedNodes)
                newExpandedNodes.add(targetGedId)
                setExpandedNodes(newExpandedNodes)
                setTreeData(clonedTree)
            } else {
                console.error('Failed to attach subtree')
            }
        } catch (err) {
            console.error('Error in expandNode:', err)
        }
    }

    return { handleNodeClick, expandedNodes }
}
